/**
 * Whether the user has asked the OS for reduced motion. Read at call time
 * (not module load): the setting can change mid-session and the consumers
 * check it at the moment an animation would start.
 */
export const prefersReducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
